<td bitCell [ngClass]="RowHeightClass" class="tw-min-w-fit">
  <input
    type="checkbox"
    bitCheckbox
    appStopProp
    *ngIf="canDeleteCollection"
    [disabled]="disabled"
    [checked]="checked"
    (change)="$event ? this.checkedToggled.next() : null"
  />
</td>
<td bitCell [ngClass]="RowHeightClass" class="tw-min-w-fit">
  <div class="icon" aria-hidden="true">
    <i class="bwi bwi-fw bwi-lg bwi-collection"></i>
  </div>
</td>
<td bitCell [ngClass]="RowHeightClass">
  <button
    bitLink
    [disabled]="disabled"
    type="button"
    class="tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-start"
    linkType="secondary"
    [routerLink]="[]"
    [queryParams]="{ collectionId: collection.id }"
    queryParamsHandling="merge"
  >
    {{ collection.name }}
  </button>
</td>
<td bitCell [ngClass]="RowHeightClass" *ngIf="showOwner">
  <app-org-badge
    [disabled]="disabled"
    [organizationId]="collection.organizationId"
    [organizationName]="collection.organizationId | orgNameFromId : organizations"
    appStopProp
  >
  </app-org-badge>
</td>
<td bitCell [ngClass]="RowHeightClass" *ngIf="showCollections"></td>
<td bitCell [ngClass]="RowHeightClass" *ngIf="showGroups">
  <app-group-badge
    *ngIf="collectionGroups"
    [selectedGroups]="collectionGroups"
    [allGroups]="groups"
  ></app-group-badge>
</td>
<td bitCell [ngClass]="RowHeightClass" class="tw-text-right">
  <button
    *ngIf="canEditCollection || canDeleteCollection"
    [disabled]="disabled"
    [bitMenuTriggerFor]="collectionOptions"
    size="small"
    bitIconButton="bwi-ellipsis-v"
    type="button"
    appA11yTitle="{{ 'options' | i18n }}"
    appStopProp
  ></button>
  <bit-menu #collectionOptions>
    <button *ngIf="canEditCollection" type="button" bitMenuItem (click)="edit()">
      <i class="bwi bwi-fw bwi-pencil-square" aria-hidden="true"></i>
      {{ "editInfo" | i18n }}
    </button>
    <button *ngIf="canEditCollection" type="button" bitMenuItem (click)="access()">
      <i class="bwi bwi-fw bwi-users" aria-hidden="true"></i>
      {{ "access" | i18n }}
    </button>
    <button *ngIf="canDeleteCollection" type="button" bitMenuItem (click)="deleteCollection()">
      <span class="tw-text-danger">
        <i class="bwi bwi-fw bwi-trash" aria-hidden="true"></i>
        {{ "delete" | i18n }}
      </span>
    </button>
  </bit-menu>
</td>
